<template>
  <va-card title="Меню">
    <va-button
      :to="{ name: 'bgk-widgets-stats-edit' }"
    >
      Створити
    </va-button>
    <va-data-table
      :fields="fields"
      :data="stats"
      no-pagination
    >
      <template slot="marker" slot-scope="props">
        <va-icon name="fa fa-circle" :color="props.rowData.value" size="8px" />
      </template>
      <template slot="marker" slot-scope="props">
        <va-icon name="fa fa-circle" :color="props.rowData.metric" size="8px" />
      </template>
      <template slot="marker" slot-scope="props">
        <va-icon name="fa fa-circle" :color="props.rowData.desc" size="8px" />
      </template>

      <template slot="toggle" slot-scope="props">
        <va-toggle
          small
          v-on:input="togglePublished(props.rowData.id)"
          v-model="props.rowData.published"
        />
      </template>

      <template slot="translations" slot-scope="props">
        <va-badge color="info" :outline="!translation.status" v-for="(translation, index) in props.rowData.trans" :key="index">{{ translation.locale }}</va-badge>
      </template>

      <template slot="actions" slot-scope="props">
        <va-button
          small
          color="info"
          :to="{ name: 'bgk-widgets-stats-edit', params: { id: props.rowData.id } }"
        >
          Редагувати
        </va-button>
      </template>
    </va-data-table>
  </va-card>
</template>

<script>
import * as axios from 'axios'
import Vue from 'vue'

export default {
  data () {
    return {
      stats: [],
    }
  },
  created () {
    this.fetch()
  },
  computed: {
    fields () {
      return [{
        name: 'key',
        title: 'Key',
        width: '10%',
      },
      {
        name: 'value',
        title: 'Value',
        width: '20%',
      },
      {
        name: 'metric',
        title: 'Metric',
        width: '20%',
      },
      {
        name: 'desc',
        title: 'Description',
        width: '20%',
      },
      {
        title: 'Опубліковано',
        name: '__slot:toggle',
        width: '20%',
      },
      {
        title: 'Переклади',
        name: '__slot:translations',
      },
      {
        name: '__slot:actions',
        dataClass: 'text-right',
      }]
    },
    locale () {
      return Vue.i18n.locale()
    },
  },
  watch: {
    locale: function (value) {
      this.fetch()
    },
  },
  methods: {
    togglePublished (id) {
      axios.put(`${process.env.VUE_APP_BGK_API_URL}/${this.locale}/admin/stats/${id}`, {
        published: !!this.stats.find((item) => item.id === id).published,
      })
        .then(response => {
          this.showToast('Success')
        })
        .catch(error => {
          console.log(error)
          this.showToast('Error')
        })
    },
    fetch () {
      // TODO: change uk to locale value
      axios.get(`${process.env.VUE_APP_BGK_API_URL}/${this.locale}/admin/stats`)
        .then(response => {
          this.stats = response.data
          this.stats.forEach((item) => {
            item.published = !!item.published
            // console.log(item.trans)
          })
        })
        .catch(error => {
          console.log(error)
          this.showToast('Error')
        })
        .finally(() => {
          this.loaded = true
        })
    },
  },
}
</script>

<style lang="scss">
</style>
